import navigateToConsoleSubscriptions from './navigateToConsoleSubscriptions'

export { navigateToConsoleSubscriptions }

export default {
  methods: {
    ...navigateToConsoleSubscriptions.methods
  }
}
